/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetObserverTokenResult } from '../../models/get-observer-token-result';

export interface ApiSessionsSessionIdObserverTokenGet$Params {

/**
 * Session to listen in on.
 */
  sessionId: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiSessionsSessionIdObserverTokenGet(http: HttpClient, rootUrl: string, params: ApiSessionsSessionIdObserverTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetObserverTokenResult>> {
  const rb = new RequestBuilder(rootUrl, apiSessionsSessionIdObserverTokenGet.PATH, 'get');
  if (params) {
    rb.path('sessionId', params.sessionId, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetObserverTokenResult>;
    })
  );
}

apiSessionsSessionIdObserverTokenGet.PATH = '/api/Sessions/{sessionId}/observer-token';
